var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.161,
    height: 23.161,
    viewBox: "0 0 23.161 23.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar-alt-svgrepo-com",
    d: "M3,10.054H24.161M7.7,3V5.351M19.459,3V5.351m-12.932,9.4H8.878m-2.351,4.7H8.878m3.527-4.7h2.351m-2.351,4.7h2.351m3.527-4.7h2.351m-2.351,4.7h2.351m-13.872,4.7H20.4a5.841,5.841,0,0,0,2.478-.256A2.351,2.351,0,0,0,23.9,22.877a5.841,5.841,0,0,0,.256-2.478V9.113A5.841,5.841,0,0,0,23.9,6.635a2.351,2.351,0,0,0-1.027-1.028A5.841,5.841,0,0,0,20.4,5.351H6.762a5.841,5.841,0,0,0-2.478.256A2.351,2.351,0,0,0,3.256,6.635,5.841,5.841,0,0,0,3,9.113V20.4a5.841,5.841,0,0,0,.256,2.478A2.351,2.351,0,0,0,4.284,23.9,5.841,5.841,0,0,0,6.762,24.161Z",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#07400b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAlt);
export default __webpack_public_path__ + "static/media/calendar-alt.a69b94d510cf5f83c2325a96afb6e54e.svg";
export { ForwardRef as ReactComponent };